<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('attendanceDevice.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="fetch_before_create">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label required">{{ $t('attendanceDevice.deviceName') }}</label>
              <input
                type="text"
                v-model="model.device_name"
                class="form-control"
                :class="{ 'is-invalid': errors.has('device_name') }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('device_name')"
              >{{ errors.first('device_name') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label required">{{ $t('attendanceDevice.deviceIp') }}</label>
              <div>
                <vue-ip
                  :ip="model.device_ip"
                  :on-change="change"
                  theme="material"
                  :class="{ 'is-invalid': errors.has('device_ip') }"
                ></vue-ip>
              </div>
              <div
                class="invalid-feedback"
                v-if="errors.has('device_ip')"
              >{{ errors.first('device_ip') }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label required">{{ $t('attendanceDevice.port') }}</label>
              <div>
                <input
                  type="number"
                  v-model="model.port"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('port') }"
                />
              </div>
              <div class="invalid-feedback" v-if="errors.has('port')">{{ errors.first('port') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label required">{{ $t('attendanceDevice.deviceType') }}</label>
              <select
                v-model.number="model.att_type_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('att_type_id') }"
              >
                <option value>--{{ $t('select') }}--</option>
                <option
                  v-for="(attDeviceType, index) in deviceTypes"
                  :key="index"
                  :value="attDeviceType.att_type_id"
                >
                  {{
                  attDeviceType.att_device_type
                  }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('att_type_id')"
              >{{ errors.first('att_type_id') }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label">{{ $t('attendanceDevice.sdkVersion') }}</label>
              <input
                type="text"
                v-model="model.sdk_version"
                class="form-control"
                :class="{ 'is-invalid': errors.has('sdk_version') }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('sdk_version')"
              >{{ errors.first('sdk_version') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label">{{ $t('attendanceDevice.remarks') }}</label>
              <textarea rows="3" class="form-control" v-model="model.remarks"></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('remarks')"
              >{{ errors.first('remarks') }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click.prevent="$emit('close')">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              class="btn-primary"
              :waiting="saving"
              @click.prevent="update"
              v-if="updating"
            >{{ $t('button.update') }}</ts-button>
            <ts-button
              class="mr-2"
              outline
              color="primary"
              :waiting="saving_add_new"
              @click.prevent="saveAddNew"
              v-if="!updating"
            >{{ $t('button.saveAddNew') }}</ts-button>
            <ts-button
              class="btn-primary"
              :waiting="saving"
              @click.prevent="store"
              v-if="!updating"
            >{{ $t('button.save') }}</ts-button>
          </div>
        </div>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'attendanceDeviceForm',
  props: ['editData'],
  data() {
    return {
      model: {
        device_id: 0,
        device_name: '',
        device_ip: '0.0.0.0',
        port: '',
        att_type_id: '',
        sdk_version: '',
        remarks: '',
        ip_isvalid: true
      },
      errors: new Errors(),
      saving: false,
      saving_add_new: false,
      updating: false,
      fetch_before_create: true
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('hr/attendanceDevice', ['deviceTypes'])
  },
  methods: {
    ...mapActions('hr/attendanceDevice', ['dataBeforeCreate']),
    change(ip, port, valid) {
      if (valid) {
        this.model.device_ip = ip
        this.model.ip_isvalid = valid
      } else {
        this.model.ip_isvalid = valid
      }
    },
    saveAddNew() {
      this.errors = new Errors()
      this.saving_add_new = true
      this.$store
        .dispatch('hr/attendanceDevice/store', this.model)
        .then(response => {
          return this.$store.dispatch('hr/attendanceDevice/fetch').then(res => {
            this.$toasted.success(response.message)
            this.clearInput()
            this.saving_add_new = false
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.saving_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/attendanceDevice/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.$emit('before-close')
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/attendanceDevice/update', {
          id: this.editData.device_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.$emit('before-close')
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async setEditData() {
      await this.dataBeforeCreate().finally(() => (this.fetch_before_create = false))
      if (!_.isEmpty(this.editData) || !this.editData === undefined) {
        this.updating = true
        this.model = {
          device_id: this.editData.device_id,
          device_name: this.editData.device_name,
          device_ip: this.editData.device_ip,
          port: this.editData.port,
          att_type_id: this.editData.att_type_id,
          sdk_version: this.editData.sdk_version,
          remarks: this.editData.remarks
        }
      }
    },
    clearInput() {
      this.model = {
        device_id: 0,
        device_name: '',
        device_ip: '0.0.0.0',
        port: '',
        att_type_id: '',
        sdk_version: '',
        remarks: ''
      }
    }
  }
}
</script>
